document.addEventListener('DOMContentLoaded', function () {
  const quantityButtons = document.querySelectorAll('.quantity-button');
  const quantityInputs = document.querySelectorAll('.quantity-input');
  const removeButtons = document.querySelectorAll('.remove-item');

  // Handle quantity button clicks
  quantityButtons.forEach(button => {
    button.addEventListener('click', async function () {
      const line = this.dataset.line;
      const cartItem = this.closest('.cart-table-item');
      const quantityInput = cartItem.querySelector('.quantity-input');
      let newQuantity = parseInt(quantityInput.value);

      if (this.classList.contains('quantity-decrease')) {
        newQuantity = Math.max(1, newQuantity - 1);
      } else if (this.classList.contains('quantity-increase')) {
        newQuantity += 1;
      }

      quantityInput.value = newQuantity;
      await updateCartItem(line, newQuantity);
    });
  });

  // Handle quantity input changes
  quantityInputs.forEach(input => {
    input.addEventListener('change', async function () {
      const line = this.dataset.line;
      const newQuantity = parseInt(this.value) || 1;
      await updateCartItem(line, newQuantity);
    });
  });

  // Handle remove button clicks
  removeButtons.forEach(button => {
    button.addEventListener('click', async function () {
      const line = this.dataset.line;
      await updateCartItem(line, 0);
    });
  });

  async function updateCartItem(line, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      });

      if (response.ok) {
        // Reload page to show updated cart
        window.location.reload();
      } else {
        const errorData = await response.json();
        alert('Erro ao atualizar carrinho: ' + (errorData.message || 'Tente novamente.'));
      }
    } catch (error) {
      console.error('Erro ao atualizar carrinho:', error);
      alert('Erro ao atualizar carrinho. Tente novamente.');
    }
  }
});
